'use client';

import Newsletter from '@/components/Newsletter';
import StoreConfig from '@/config';
import { useSwitchCountry } from '@/hooks/use-switch-country';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import FooterMenu from './footerMenu';
import SiteServe from './site-serve';
import SocialLinks from './social-links';

const PaymentImages = dynamic(() => import('../payment-images'), { ssr: false, loading: () => <div /> });

const Footer = () => {
  const { handleSwitchCountry } = useSwitchCountry();

  const pathname = usePathname();

  const isWhoIsYourCharacterGame = pathname === '/who-is-your-character';
  const isCustomizeDressPage = pathname === StoreConfig.customize_dress_url;

  const isCartPage = pathname === '/cart';

  const currentCountryCode = StoreConfig.current_country_code;

  const availableCountries = StoreConfig.available_countries;

  const currentCountry = useMemo(() => {
    return availableCountries.find(temp => temp.code === currentCountryCode);
  }, [availableCountries, currentCountryCode]);

  const countryList = (
    <>
      <div className='text-[17px] leading-[1.4] text-[#403732]'>SHOPPING FROM</div>
      <div className='mt-6 flex flex-col  justify-start  text-[15px] leading-[1.4] text-[#403732]'>
        <p className='flex w-full items-center md_w-auto'>
          You&apos;re in{' '}
          <img
            className='ml-2.5 h-auto w-7'
            src={currentCountry.icon}
            alt={currentCountry.name}
          />
        </p>
        <p className=' mt-[14px] flex w-full flex-col items-start gap-x-4 gap-y-2.5 lg_flex-row '>
          <span>Some of our international sites:</span>
          <span className='flex flex-wrap gap-3'>
            {availableCountries.map(country => {
              if (country.hideInOptions) return null;

              let href = country.url;

              if (country.sharedLanguageSite) {
                const urlInstance = new URL(country.url);
                urlInstance.searchParams.append('country', country.code.toUpperCase());
                href = urlInstance.toString();
              }

              return (
                <Link
                  onClick={e => {
                    e.preventDefault();
                    handleSwitchCountry(country.code);
                  }}
                  key={country.code}
                  href={href}
                  className='flex-none'
                  prefetch={false}
                >
                  <img
                    className='h-auto w-7'
                    src={country.icon}
                    alt=''
                  />
                </Link>
              );
            })}
          </span>
        </p>
      </div>
    </>
  );

  if (isWhoIsYourCharacterGame) return null;

  return (
    <footer className={clsx((isCartPage || isCustomizeDressPage) && 'hidden', 'lg_block', 'min-h-0 flex-none')}>
      <SiteServe />

      <div className='bg-f8f3ef lg_mt-[5px]'>
        <div className='lg_py-20'>
          <div className='mx-auto max-w-site justify-between gap-x-5 px-4 lg_flex lg_items-start lg_px-0 '>
            <div className='py-[30px] lg_py-0'>
              <p className='font-Shango text-[26px] leading-8 text-#403732'>GET 5% OFF AND MORE!</p>
              <Newsletter />
              <SocialLinks />
              <div className='mt-[35px] lg_hidden'>{countryList}</div>
            </div>
            <FooterMenu />
          </div>
          <div className='mx-auto mt-2.5 hidden max-w-site lg_block'>{countryList}</div>
        </div>
        <div className='mx-auto flex max-w-site flex-col gap-y-2.5 px-2.5 py-[30px] lg_flex-row lg_items-center lg_justify-between lg_px-0 lg_py-2'>
          <PaymentImages
            svgClassName='h-auto lg_w-[52px]'
            className='gap-[5px]'
          />

          <div className='text-center text-[13px] leading-[18px] text-[#6d6b6b] lg_leading-4'>
            © 2009-{year} AW.Bridal Ltd., All Right Reserved.&nbsp;
            <br className='lg_hidden' />
            <Link
              href='/privacy-policy'
              className='lg_hover_text-80583F lg_hover_underline'
            >
              Privacy Policy
            </Link>
            &nbsp;|&nbsp;
            <Link
              href='/terms-and-conditions'
              className='lg_hover_text-80583F lg_hover_underline'
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

const year = new Date().getFullYear();

export default Footer;
